import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { SelectOptionI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { State } from '../../reducers';
import { plantWithPreloaded } from '../../selectors/one-click-plants.selector';
import { OneClickBuilderField } from '../../util/constants/builder-fields';

@Injectable()
export class OneClickPlantsLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup, config?: FieldConfig): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(plantWithPreloaded(config['at'])),
      filter(({ plants }) => !!plants && !!plants.length),
      map(({ plants, preloadedOrder }) => {
        if (preloadedOrder) {
          const _plants = plants.find((p) => p.plantId === preloadedOrder.items[0].shippingSource.shippingSourceId);
          _plants && formGroup.controls[OneClickBuilderField.Plant].setValue(_plants.plantId);
        }
        return plants.map((plant) => {
          return {
            id: plant.plantId,
            name: plant.plantDesc,
          };
        });
      }),
    );
  }
}
